<template>
  <div class="content">
    <div class="banner"></div>
    <div class="home-btn" @click="toHome()"></div>
    <div class="main-content">
      <span class="pc-back" @click="back"></span>
      <div class="news-title" />

      <div class="list-bg">
        <ul class="nav">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="{ active: activeNavId == item.id }"
            @click="(activeNavId = item.id), (currentPage = 0)"
          >
            <img
              v-if="activeNavId == item.id"
              :src="item.bgImageActiveUrlMobile"
              :alt="index"
              class="nav-item--mobile nav-item-bgImageActiveUrl--mobile"
            />
            <img
              v-else
              :src="item.bgImageUrlMobile"
              :alt="index"
              :class="`nav-item--mobile nav-item-bgImageUrl--mobile nav-item-bgImageUrl--mobile-${index}`"
            />
            <img
              v-if="activeNavId == item.id"
              :src="item.bgImageActiveUrl"
              :alt="index"
              class="nav-item--pc nav-item-bgImageActiveUrl--pc"
            />
            <img
              v-else
              :src="item.bgImageUrl"
              :alt="index"
              :class="`nav-item--pc nav-item-bgImageUrl--pc nav-item--pc nav-item-bgImageUrl--pc-${index}`"
            />
          </li>
        </ul>

        <div class="list">
          <ul class="list-content">
            <li
              class="item"
              v-for="(item, index) in listData"
              :key="index"
              @click="toDetail(item)"
            >
              <div class="top">
                <span class="title">{{ item.articleTitle }}</span>
                <span class="time">{{
                  item.deployTime | formatTimeToDate
                }}</span>
                <span class="year">{{
                  item.deployTime | formatTimeToYear
                }}</span>
              </div>
              <p class="item-content">
                {{ item.articleIntro }}
              </p>
            </li>
          </ul>

          <Pagenation
            :isShowPrevAndNext="true"
            :currentPage="currentPage"
            :dataLength="listData.length"
            :displayNumOfEachPage="displayNumOfEachPage"
            :pages="pages"
            @itemClick="itemClick"
            @prevClick="prevClick"
            @nextClick="nextClick"
          />
        </div>
      </div>
    </div>
    <!-- 浮窗 -->
    <SiderBar />
  </div>
</template>

<script>
import SiderBar from '../components/SiderBar';
import Pagenation from '../components/pagenation';
import { getArticle, getArticleClass } from '@/api/index.js';
export default {
  data() {
    return {
      displayNumOfEachPage: 4,
      currentPage: 0,
      activeNavId: null,
      navList: [
        {
          name: '动态',
          value: 'all',
          id: null,
          bgImageUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-1.png',
          bgImageActiveUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-1--active.png',
          bgImageUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-1--mobile.png',
          bgImageActiveUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-1--active--mobile.png',
        },
        {
          name: '事件',
          value: 'Sự Kiện',
          bgImageUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-2.png',
          bgImageActiveUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-2--active.png',
          bgImageUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-2--mobile.png',
          bgImageActiveUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-2--active--mobile.png',
        },
        {
          name: '引导',
          value: 'Hướng Dẫn',
          bgImageUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-3.png',
          bgImageActiveUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-3--active.png',
          bgImageUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-3--mobile.png',
          bgImageActiveUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-3--active--mobile.png',
        },
        {
          name: '综合',
          value: 'Cộng Đồng',
          bgImageUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-4.png',
          bgImageActiveUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-4--active.png',
          bgImageUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-4--mobile.png',
          bgImageActiveUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list-page-nav-4--active--mobile.png',
        },
      ],
      listData: [],
      pages: 1, // 页数
    };
  },
  created() {
    this.fetchArticleList();
    this.fetchArticleClassList();
  },
  watch: {
    activeNavId(val) {
      this.fetchArticleList(val);
    },
  },
  filters: {
    formatTimeToDate: function (value) {
      if (!value) return '';
      return value.slice(5, 10);
    },
    formatTimeToYear: function (value) {
      if (!value) return '';
      return value.slice(0, 4);
    },
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path: '/detail',
        query: { id: item.articleId },
      });
    },
    toHome() {
      this.$router.push('/');
    },
    back() {
      this.$router.push('/');
    },
    prevClick() {
      if (this.currentPage !== 0) {
        this.currentPage = this.currentPage - 1;
        this.fetchArticleList(this.activeNavId, this.currentPage + 1);
      }
    },
    nextClick() {
      const newPageNum = this.currentPage + 1;
      if (newPageNum < this.pages) {
        this.currentPage = newPageNum;
        this.fetchArticleList(this.activeNavId, newPageNum + 1);
      }
    },
    itemClick(page) {
      if (page !== -1) {
        this.currentPage = page - 1;
      }
    },
    async fetchArticleClassList() {
      const res = await getArticleClass({
        gameCode: 'ddj-vn',
        parentId: 0,
      });
      const records = res?.data ?? [];
      if (records.length === 0) return;
      this.navList = this.navList.map((el, index) =>
        index > 0
          ? {
              ...el,
              id: records[index - 1]['id'],
            }
          : el,
      );
    },
    async fetchArticleList(articleClass = null, current = 1, size = 4) {
      const res = await getArticle({
        gameCode: 'ddj-vn',
        articleClass,
        size,
        current,
      });
      const records = res.data?.records ?? [];
      this.listData = records;
      this.pages = res.data?.pages ?? 1;
    },
  },
  components: {
    Pagenation,
    SiderBar,
  },
};
</script>

<style lang="scss">
// app
@media screen and (max-width: 768px) {
  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/m_list_bg.png)
      0 0 no-repeat;
    background-size: cover;

    .banner {
      width: 100%;
      height: 410px;
    }
    .home-btn {
      display: none;
    }
    .main-content {
      width: 100%;
      text-align: center;
      padding: 0 0 109px 0;
      .pc-back {
        width: 42px;
        height: 42px;
        left: 20px;
        top: 361px;
        position: absolute;
        cursor: pointer;
        background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/back_btn.png)
          no-repeat 0 0;
        background-size: contain;
      }
      .news-title {
        margin: 60px auto 0 auto;
        width: 490px;
        height: 63px;
        background: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/m_news_title.png)
          no-repeat 0 0;
        background-size: cover;
      }

      .list-bg {
        width: 100%;
        height: 991px;
        padding: 0 28px;
        margin: 50px auto 0 auto;
        .nav {
          width: 100%;
          height: 57px;
          display: flex;
          justify-content: center;
          margin-bottom: 38px;
          li {
            font-family: 'GenJyuuGothic-P-Regular';
            height: 28px;
            font-size: 30px;
            line-height: 36px;
            letter-spacing: 0px;
            text-align: center;
            color: #404040;
            margin: 0 29px;
            cursor: pointer;
            .nav-item--pc {
              display: none;
            }
            .nav-item--mobile {
              height: 33.2px;
              width: auto;
            }
            .nav-item-bgImageUrl--mobile-0 {
              height: 25px;
            }
            .nav-item-bgImageActiveUrl--mobile {
              height: 43px;
            }
          }
        }
        .list {
          height: 970px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          background: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/m_news_list_bg.png)
            no-repeat 0 0;
          background-size: cover;
          padding: 20px 30px;
          .list-content {
            .item {
              padding: 30px 0 30px 0;
              border-bottom: 1px dashed #e0e0e0;
              .top {
                display: flex;
                width: 100%;
                justify-content: flex-end;
                align-items: flex-end;
                .title {
                  flex-grow: 2;
                  text-align: left;
                  font-size: 30px;
                  font-family: 'GenJyuuGothic-P-Regular';
                  color: #bf703c;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 30px;
                  letter-spacing: 1px;
                }
                .year {
                  display: none;
                  text-align: center;
                  padding: 4px 8px;
                  color: #e8cbad;
                  font-size: 16px;
                  line-height: 16px;
                  margin-left: 19px;
                  font-family: 'GenJyuuGothic-P-Regular';
                  border: 1px solid #e8cbad;
                  letter-spacing: 1px;
                }
                .time {
                  float: right;
                  color: #e8cbad;
                  font-size: 34px;
                  font-family: 'SourceHanSansCN-Bold';
                  line-height: 37px;
                }
              }
              .item-content {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                text-indent: 2em;
                text-align: left;
                margin-top: 24px;
                font-family: 'GenJyuuGothic-P-Regular';
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 37px;
                letter-spacing: 3px;
                color: #404040;
              }
            }
          }

          .pagination {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            // .button {
            //   padding: 6px 12px;
            //   width: 100px;
            // }

            li {
              text-align: center;
              font-family: 'GenJyuuGothic-P-Regular';
              font-size: 20px;
              line-height: 32px;
              font-weight: normal;
              font-stretch: normal;
              color: #e8cbad;
              padding: 6px 0;
              height: 44px;
              width: 44px;
              margin: 20px 5px;
              border: 1px solid #e8cbad;
              border-radius: 22px;
              cursor: pointer;
              &.active,
              &:hover {
                color: #fff;
                background-color: #e8cbad;
              }
            }
          }
        }
      }
    }
  }
}
// pc
@media screen and (min-width: 769px) {
  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list_bg.png)
      0 0 no-repeat;
    background-size: cover;

    .banner {
      width: 100%;
      height: 324px;
    }
    .home-btn {
      position: absolute;
      width: 163px;
      height: 49px;
      left: 143px;
      top: 204px;
      background: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/list_back.png)
        no-repeat 0 0;
      background-size: cover;
    }
    .main-content {
      text-align: center;
      padding: 0 0 109px 0;
      .pc-back {
        display: none;
      }
      .news-title {
        margin: 60px auto 0 auto;
        width: 554px;
        height: 71px;
        background: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/news.png)
          no-repeat 0 0;
        background-size: cover;
      }
      .nav {
        width: 100%;
        height: 85px;
        display: flex;
        justify-content: center;
        li {
          padding-top: 20px;
          margin: 0 29px;
          cursor: pointer;
          .nav-item--pc {
            width: auto;
            height: 33px;
          }
          .nav-item-bgImageUrl--pc-0 {
            height: 25px;
          }
          .nav-item-bgImageActiveUrl--pc {
            height: 43px;
          }
          .nav-item--mobile {
            display: none;
          }
        }
      }
      .list {
        width: 974px;
        height: 930px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/pc_news_list_bg.png)
          no-repeat 0 0;
        background-size: cover;
        padding: 15px 100px;

        .list-content {
          .item {
            padding: 30px 0 30px 0;
            border-bottom: 1px dashed #e0e0e0;
            cursor: pointer;
            &.active,
            &:hover {
              .top {
                .title {
                  color: #bf703c;
                }
              }
              .item-content {
                color: #bf703c;
              }
            }
            .top {
              display: flex;
              width: 100%;
              justify-content: flex-end;
              align-items: flex-end;
              .title {
                flex-grow: 2;
                text-align: left;
                font-size: 30px;
                font-family: 'GenJyuuGothic-P-Regular';
                color: #404040;
                font-weight: normal;
                font-stretch: normal;
                line-height: 30px;
                letter-spacing: 1px;
              }
              .year {
                text-align: center;
                padding: 4px 8px;
                color: #e8cbad;
                font-size: 16px;
                line-height: 16px;
                margin-left: 19px;
                font-family: 'GenJyuuGothic-P-Regular';
                border: 1px solid #e8cbad;
                letter-spacing: 1px;
              }
              .time {
                float: right;
                color: #e8cbad;
                font-size: 34px;
                font-family: 'SourceHanSansCN-Bold';
                line-height: 37px;
              }
            }
            .item-content {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              text-indent: 2em;
              text-align: left;
              margin-top: 18px;
              font-family: 'GenJyuuGothic-P-Regular';
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 27px;
              letter-spacing: 0px;
              color: #404040;
            }
          }
        }

        .pagination {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;

          // .button {
          //   padding: 6px 12px;
          //   width: 100px;
          // }

          li {
            text-align: center;
            font-family: 'GenJyuuGothic-P-Regular';
            font-size: 20px;
            line-height: 32px;
            font-weight: normal;
            font-stretch: normal;
            color: #e8cbad;
            padding: 6px 0;
            height: 44px;
            width: 44px;
            margin: 20px 10px;
            border: 1px solid #e8cbad;
            border-radius: 22px;
            cursor: pointer;
            &.active,
            &:hover {
              color: #fff;
              background-color: #e8cbad;
            }
          }
        }
      }
    }
  }
}
</style>
